/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <b-card no-body>
    <b-card-header header-tag="header" role="tab">
      <button v-b-toggle="'accordion-' + attribute.key" class="btn btn-none accordion-title d-flex align-items-center justify-content-between">
        <div class="title">{{attribute.label}}</div>
        <svg class="o-icon"><use xlink:href="#plus-circle"></use></svg>
      </button>
    </b-card-header>
    <b-collapse :id="`accordion-${attribute.key}`" accordion="info-product" role="tabpanel">
      <b-card-body>
        <div class="attribute-wrapper">
          <div class="attribute-row">
            <ul>
              <li v-for="(contain, index) in validContains" :key="index">
                <span class="label" v-show="contain.label">{{ contain.label }}: </span>
                <span class="value" :class="[`value-${contain.key}`]">{{ getValue(contain) }}</span>
              </li>
            </ul>
          </div>
        </div>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>

export default {
  name: 'AccordionTecnicalData',
  props: {
    attribute: {
      type: Object,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    variantSelected: {
      type: Array | Object,
      required: false
    }
  },
  computed: {
    validContains () {
      if (this.attribute && this.attribute.contains) {
        return this.attribute.contains.filter((c) => c.value)
      } else {
        return []
      }
    }
  },
  methods: {
    getValue (contain) {
      if (Array.isArray(this.variantSelected) && this.variantSelected.length === 1) {
        var obj = this.variantSelected[0].attributesLabel.find((v) => v.attribute_code === contain.key)
        return obj.value || contain.value
      } else {
        return contain.value
      }
    }
  }
}
</script>
